import React, { useRef, useState, useEffect } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";
import { Button, Grid, Typography } from "@material-ui/core";
import { filter, range } from "lodash";
import "animate.css/animate.css";

const MCQS = (props) => {
  const {
    classes,
    onSubmit,
    currentQuestion,
    setAnsweredCorrectly,
  } = props;

  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0)
  const [selectedAnswer, setSelectedAnswer] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [isCorrect, setIsCorrect] = useState(false)

  const handleAnswerSelect = (answer) => {
    setSelectedAnswer(answer)
  }

  return (
    <div className={classes.quizContainer}>
      <div className={classes.quizContent}>
        <p className={classes.quizIntroduction} dangerouslySetInnerHTML={{ __html: currentQuestion.context }} />
        <div className={classes.quizContext}>
          <p className={classes.quizContextText}>{currentQuestion.introduction}</p>
        </div>
        <p className={classes.quizQuestion}>{currentQuestion.question}</p>
      </div>

      <div className={classes.quizOptions}>
        {currentQuestion.options.map((option) => (
          <button
            key={option}
            onClick={() => handleAnswerSelect(option)}
            className={`${classes.quizOption} ${selectedAnswer === option && classes.quizOptionSelected}`}
          >
            {option}
          </button>
        ))}
      </div>

      <button 
        onClick={() =>{
            setAnsweredCorrectly(selectedAnswer === currentQuestion.answer)
            onSubmit(currentQuestion)
            setSelectedAnswer('')
        }}
        className={`${classes.quizNextButton} ${!(selectedAnswer) && classes.quizNextButtonDisabled }`}
        disabled={!(selectedAnswer)}
      >
        Next
      </button>

      {/* {showModal && (
        <div className={classes.modal}>
          <div className={classes.modalContent}>
            <h2 className={classes.modalTitle}>{isCorrect ? 'Correct!' : 'Incorrect'}</h2>
            <p className={classes.modalText}>
              {isCorrect 
                ? "Great job! You've selected the correct answer." 
                : "Sorry, that's not correct. The correct answer is 58%."}
            </p>
            {isCorrect && (
              <div className={classes.modalCalculation}>
                <p><strong>Here's the calculation:</strong></p>
                <p>Total Population = 11 + 8 = 19</p>
                <p>Labor Force Participation Rate = (11 ÷ 19) × 100 = 58%</p>
              </div>
            )}
            <button onClick={handleCloseModal} className={classes.modalButton}>
              {currentQuestionIndex < questions.length - 1 ? 'Next Question' : 'Finish Quiz'}
            </button>
          </div>
        </div>
      )} */}
    </div>
  )
};

export default withStyles(styles)(MCQS);
